<template>
  <tr>
    <th>
      소식 종류
      <span v-if="required" class="required">*</span>
    </th>
    <td>
      <div class="form_group type_radio">
        <input type="radio" :id="`repeat_news_type_${uuid}`" :name="`news_type_${uuid}`" value="REPEAT" v-model="newsType_local" />
        <label :for="`repeat_news_type_${uuid}`">반복소식</label>
      </div>
      <div class="form_group type_radio">
        <input type="radio" :id="`custom_news_type_${uuid}`" :name="`news_type_${uuid}`" value="CUSTOM" v-model="newsType_local" />
        <label :for="`custom_news_type_${uuid}`">맞춤소식 :</label>
      </div>
      <div class="form_group">
        <select v-model="customNewsType_local" :disabled="newsType_local != 'CUSTOM'" ref="selectBox">
          <option value>맞춤소식 종류</option>
          <option v-for="(item, key) in customNewsTypes" :key="key" :value="key">{{ item.full }}</option>
        </select>
      </div>
      <div class="btn_area type_fr">
        <HelpButton contentId="HELP_01" />
      </div>
    </td>
  </tr>
</template>

<script>
import newsMixin from '$views/News/_mixin';

export default {
  mixins: [newsMixin],
  props: {
    newsType: {
      type: String,
      default: 'REPEAT',
    },
    customNewsType: {
      type: String,
      default: '',
    },
    required: Boolean,
  },
  data() {
    return {
      newsType_local: this.newsType,
      customNewsType_local: this.customNewsType,
    };
  },
  watch: {
    newsType_local(val) {
      this.$emit('update:newsType', val);
    },
    customNewsType_local(val) {
      this.$emit('update:customNewsType', val);
    },
  },
  methods: {
    validate() {
      if (!this.required) return true;

      if (this.newsType === 'CUSTOM' && !this.customNewsType) {
        alert('맞춤소식 종류를 선택해 주세요');
        this.$refs.selectBox.focus();
        return false;
      }

      return true;
    },
  },
};
</script>

<style></style>
